module.exports = __webpack_public_path__ + "img/dangerHubHeader2.ce3404ca.png";